import { post, get, _delete, put } from "@/utils/axiosInstance";
import { ENDPOINTS, statuses } from "../../constants";
import { getItem } from "../../utils/tokenTools";

const state = {
  packageData: { data: [], page: {} },
  packageDetail: [],
  draftPackageDetail: [],
  recommendedPackageDetail: [],
  packageSummary: [],
  draftSummary: [],
  filterList: [],
  recommendedPackages: [],
  recommendedAllPackages: [],
  filterData: {},
  apps: [],
  allResearch: [],
  allApplicationTypes: [],
  allPlatforms: [],
  allPerspectives: [],
  allAKDs: [],
  allMarkets: [],
  allAlgorithmAndServers: [],
  representativeUsers: { data: [], page: {} },
  represReport: { data: [], page: {} },
  profAlgoApps: [],
  updateAlgorithmAndServerResponse: null,
  createAlgorithmAndServerResponse: null,
  updateApplicationTypeResponse: null,
  createApplicationTypeResponse: null,
  updatePlatformResponse: null,
  createPlatformResponse: null,
  updatePerspectiveResponse: null,
  createPerspectiveResponse: null,
  updateAKDResponse: null,
  createAKDResponse: null,
  updateMarketResponse: null,
  createMarketResponse: null,
  updatePackageResponse: null,
  createPackageResponse: null,
  algorithmCreateResponse: null,
  researchCreateResponse: null,
  packageStatusUpdate: null,
  overallLimit: {},
  generalFilter: {
    page: 1,
    size: 100,
  },
  userRole: {
    page: 1,
    size: 10,
  },
  recommendedFilter: {
    page: 1,
    size: 5,
  },
  invoiceFilter: {
    page: 1,
    size: 100,
    orderBy: {
      key: "StartDate",
      value: "desc",
    },
  },
  historyFilter: {
    page: 1,
    size: 100,
  },
  appsTab: null,
  profAlgoTab: null,
  history: { data: [], page: {} },
  historyList: { data: [], page: {} },
  cancelPackage: [],
  deleteApplicationType: [],
  deletePlatform: [],
  deletePerspective: [],
  deleteAKD: [],
  deleteMarket: [],
  deleteAlgorithmAndServer: [],
  confirm: {},
  invoiceList: { data: [], page: {} },
  representativeReport: { data: [], page: {} },
  purchaseActivatedStatus: [],
  recommendationSummary: [],
  purchaseChangeStartDate: null,
  researchList: [],
  foreignList: [],
  productPackageManagementFilter: {
    year: null,
    month: null,
    inputVal: null,
  },
  productPackageManagementAlgoFilter: {
    year: null,
    month: null,
    inputVal: null,
  },
  productPackageManagementResearchFilter: {
    year: null,
    month: null,
    inputVal: null,
  },
  productPackageManagementProductFilter: {
    year: null,
    month: null,
    inputVal: null,
  },
  productPackageManagementForeignFilter: {
    year: null,
    month: null,
    inputVal: null,
  },
  isPurchaseOrUpgradeHappend: false,
  isUpgradeHappend: false,
  branchList: [],
};

const actions = {
  clearPackages({ commit }) {
    commit("setPackages", { data: [], page: {} });
  },
  getBranchListForFilter({ commit }) {
    return new Promise((resolve) => {
      get(`${ENDPOINTS.getBranchListForFilter}`).then(({ data }) => {
        if (data) {
          let arrayObj;
          arrayObj = data.map((item) => {
            return {
              code: item.key,
              label: item.value,
              checked: false,
            };
          });
          commit("setBranchList", arrayObj);
          resolve(data);
        } else {
          resolve(false);
        }
      });
    });
  },
  // eslint-disable-next-line no-unused-vars
  getScreenPrices({ commit }, args) {
    return new Promise((resolve) => {
      get(
        `${ENDPOINTS.screenPrices}/${args.applicationId}/${args.platformId}/${args.researchId}`
      ).then(({ data }) => {
        if (data) {
          resolve(data);
        } else {
          resolve(false);
        }
      });
    });
  },
  // eslint-disable-next-line no-unused-vars
  getFeatureScreenPrices({ commit }, args) {
    return new Promise((resolve) => {
      get(`${ENDPOINTS.featureScreenPrices}`).then(({ data }) => {
        if (data) {
          resolve(data);
        } else {
          resolve(false);
        }
      });
    });
  },
  // eslint-disable-next-line no-unused-vars
  getCheckForPurchaseUpgrade({ commit }, args) {
    return new Promise((resolve) => {
      get(
        `${ENDPOINTS.checkForPurchaseUpgrade}?applicationId=${args.applicationId}&platformId=${args.platformId}`,
        {},                
        localStorage.getItem("userCusId")        
      ).then(({ data }) => {
        if (data) {
          resolve(data);
        } else {
          resolve(false);
        }
      });
    });
  },
  getAllPackages({ commit }, customerId) {
    return new Promise((resolve) => {
      post(ENDPOINTS.getAllPackages, state.generalFilter, {}, customerId).then(
        ({ data }) => {
          if (data.data) {
            commit("setPackages", data);
            resolve(true);
          } else {
            resolve(false);
          }
        }
      );
    });
  },
  getRecommendedPackageList({ commit }, cusId = null) {
    return new Promise((resolve) => {
      get(ENDPOINTS.getRecommendedPackageList, {}, cusId).then(({ data }) => {
        if (data) {
          if (data.statusCode !== statuses.INTERNAL_SERVER_ERROR) {
            const getData = data;

            getData.forEach((el) => {
              el.isOpened = false;
            });
            commit("setRecommendedPackages", getData);
            if (data.length > 0) {
              resolve(true);
            }
          }
        } else {
          resolve(false);
        }
      });
    });
  },
  getRecommendedAllPackageList({ commit }) {
    return new Promise((resolve) => {
      post(
        ENDPOINTS.getRecommendedPackageAllList,
        state.recommendedFilter,
        {}
      ).then(({ data }) => {
        if (data.data) {
          commit("setRecommendedAllPackages", data);
          resolve(true);
        } else {
          resolve(false);
        }
      });
    });
  },
  // eslint-disable-next-line no-unused-vars
  postRecommendedPackageOrderIncrease({ commit }, id) {
    return new Promise((resolve) => {
      post(`${ENDPOINTS.recommendedPackageOrderIncrease}/${id}`).then(
        ({ data }) => {
          if (data.data) {
            resolve(data);
          } else {
            resolve(false);
          }
        }
      );
    });
  },
  // eslint-disable-next-line no-unused-vars
  postAlgorithmPurchaseExportExcel({ commit }, args) {
    return new Promise((resolve) => {
      post(ENDPOINTS.algorithmPurchaseExportExcel, args).then(({ data }) => {
        if (data) {
          resolve(data);
        } else {
          resolve(false);
        }
      });
    });
  },
  // eslint-disable-next-line no-unused-vars
  postRecommendedPackageOrderDecrease({ commit }, id) {
    return new Promise((resolve) => {
      post(`${ENDPOINTS.recommendedPackageOrderDecrease}/${id}`).then(
        ({ data }) => {
          if (data.data) {
            resolve(data);
          } else {
            resolve(false);
          }
        }
      );
    });
  },
  getPackageDetail({ commit }, [id, cusId = null]) {
    return new Promise((resolve, reject) => {
      get(`${ENDPOINTS.getPackageDetail}/${id}`, {}, cusId)
        .then((response) => {
          commit("setPackageDetail", response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getDraftPackageDetail({ commit }, [id, cusId = null]) {
    return new Promise((resolve, reject) => {
      get(`${ENDPOINTS.getDraftPackageDetail}/${id}`, {}, cusId)
        .then((response) => {
          commit("setDraftPackageDetail", response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getRecommendedPackageDetail({ commit }, id) {
    return new Promise((resolve, reject) => {
      get(`${ENDPOINTS.getRecommendedPackageDetail}/${id}`)
        .then((response) => {
          commit("setRecommendedPackageDetail", response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  cancelPackage({ commit }, id) {
    return new Promise((resolve, reject) => {
      _delete(`${ENDPOINTS.cancelPackage}/${id}`)
        .then((response) => {
          commit("setCancelPackage", response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // eslint-disable-next-line no-unused-vars
  cancelRecommendedPackage({ commit }, id) {
    return new Promise((resolve, reject) => {
      _delete(`${ENDPOINTS.cancelRecommendedPackage}/${id}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fillFilter({ commit }) {
    return new Promise((resolve, reject) => {
      get(`${ENDPOINTS.fillFilter}/`)
        .then((response) => {
          commit("setFilterList", response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  checkMonthClosingProcessStatus() {
    return new Promise((resolve, reject) => {
      get(`${ENDPOINTS.checkMonthClosingProcessStatusURL}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  monthlyExcelList() {
    return new Promise((resolve, reject) => {
      get(`${ENDPOINTS.monthClosingExportUnderOverallCustomersURL}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  monthlyGetOverallLimit({ commit }) {
    return new Promise((resolve, reject) => {
      get(`${ENDPOINTS.monthClosingGetCurrentOverallLimit}`)
        .then((response) => {
          commit("setOverallLimit", response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  monthClosingGetDepartmentList() {
    return new Promise((resolve, reject) => {
      get(`${ENDPOINTS.monthClosingDepartmentList}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  sendMonthlyMail() {
    return new Promise((resolve, reject) => {
      get(`${ENDPOINTS.monthClosingSendOverallNotificationMailURL}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getMonthOverall() {
    return new Promise((resolve, reject) => {
      get(`${ENDPOINTS.monthClosingOverallURL}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getMonthClosedLogList() {
    return new Promise((resolve, reject) => {
      get(`${ENDPOINTS.monthClosingListURL}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getMonthClosingMailTemplates() {
    return new Promise((resolve, reject) => {
      get(`${ENDPOINTS.monthClosingMailTemplates}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getApps({ commit }, typeId) {
    return new Promise((resolve, reject) => {
      get(`${ENDPOINTS.getApps}/${typeId}`)
        .then((response) => {
          const filteredResponse = response.data.filter(
            (item) => !(item.id === 6697 && item.applicationId === 2)
          );
          commit("setApps", filteredResponse);
          resolve(filteredResponse);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllResearch({ commit }) {
    return new Promise((resolve, reject) => {
      get(ENDPOINTS.getAllResearch)
        .then((response) => {
          commit("setAllResearch", response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getProfAlgoApps({ commit }, [typeId, featureType, cusId = null]) {
    let param = featureType ? `?featureTypeId=${featureType}` : "";
    return new Promise((resolve, reject) => {
      get(`${ENDPOINTS.getProfAlgoApps}/${typeId}${param}`, {}, cusId)
        .then((response) => {
          commit("setProfAlgoApps", response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updatePackage({ commit }, args) {
    return new Promise((resolve) => {
      post(ENDPOINTS.updatePackage, args, {}, args.cusId).then(({ data }) => {
        if (data) {
          commit("setUpdatePackage", data);
          resolve(data);
        } else {
          resolve(false);
        }
      });
    });
  },
  updateRecommendationPackage({ commit }, args) {
    return new Promise((resolve) => {
      post(ENDPOINTS.updateRecommendationPackage, args).then(({ data }) => {
        if (data) {
          commit("setUpdateRecommendationPackage", data);
          resolve(data);
        } else {
          resolve(false);
        }
      });
    });
  },
  // eslint-disable-next-line no-unused-vars
  monthClosingPostSelectedDepartment({ commit }, args) {
    return new Promise((resolve) => {
      post(ENDPOINTS.monthClosingSelectedDepartment, args).then(({ data }) => {
        if (data) {
          resolve(data);
        } else {
          resolve(false);
        }
      });
    });
  },
  // eslint-disable-next-line no-unused-vars
  monthClosingDateTime({ commit }, args) {
    return new Promise((resolve) => {
      get(ENDPOINTS.monthClosingDateTime, args).then(({ data }) => {
        if (data) {
          resolve(data);
        } else {
          resolve(false);
        }
      });
    });
  },
  createPackage({ commit }, args) {
    return new Promise((resolve) => {
      post(
        ENDPOINTS.createPackage,
        args,
        {},
        getItem("userCusId") ?? getItem("userId")
      ).then(({ data }) => {
        if (data) {
          commit("setCreatePackage", data);
          resolve(data);
        } else {
          resolve(false);
        }
      });
    });
  },
  // eslint-disable-next-line no-unused-vars
  createRecommendationPackage({ commit }, args) {
    return new Promise((resolve) => {
      post(ENDPOINTS.createRecommendationPackage, args).then(({ data }) => {
        if (data) {
          resolve(data);
        } else {
          resolve(false);
        }
      });
    });
  },
  algorithmCreate({ commit }, argsAlgo) {
    return new Promise((resolve) => {
      post(ENDPOINTS.createAlgorithm, argsAlgo, {}, argsAlgo.cusId).then(
        ({ data }) => {
          if (data) {
            commit("setAlgorithmCreate", data);
            resolve(data);
          } else {
            resolve(false);
          }
        }
      );
    });
  },
  researchCreate({ commit }, argsResearch) {
    return new Promise((resolve) => {
      post(ENDPOINTS.createResearch, argsResearch, {}, getItem("userCusId") ?? getItem("userId")).then(
        ({ data }) => {
          if (data) {
            commit("setResearchCreate", data);
            resolve(data);
          } else {
            resolve(false);
          }
        }
      );
    });
  },
  confirm({ commit }, args) {
    return new Promise((resolve) => {
      post(ENDPOINTS.confirm, args, {}, args.cusId).then(({ data }) => {
        if (data) {
          commit("setConfirm", data);
          resolve(data);
        } else {
          resolve(false);
        }
      });
    });
  },
  getPackageSummary({ commit }, packageNumber) {
    return new Promise((resolve) => {
      get(`${ENDPOINTS.getPackageSummary}/${packageNumber}`).then(
        ({ data }) => {
          if (data) {
            commit("setPackageSummary", data);
            resolve(true);
          } else {
            resolve(false);
          }
        }
      );
    });
  },
  getDraftSummary({ commit }, packageNumber) {
    return new Promise((resolve) => {
      get(`${ENDPOINTS.getDraftPackageDetail}/${packageNumber}`).then(
        ({ data }) => {
          if (data) {
            commit("setDraftSummary", data);
            resolve(true);
          } else {
            resolve(false);
          }
        }
      );
    });
  },
  getRecommendationSummary({ commit }, packageNumber) {
    return new Promise((resolve) => {
      get(`${ENDPOINTS.getRecommendationSummary}/${packageNumber}`).then(
        ({ data }) => {
          if (data) {
            commit("setRecommendationSummary", data);
            resolve(true);
          } else {
            resolve(false);
          }
        }
      );
    });
  },
  getPurchaseChangeStartDate({ commit }, args) {
    return new Promise((resolve) => {
      if (args.cusId === undefined) {
        args.cusId = null;
      }
      post(ENDPOINTS.getPurchaseChangeStartDate, args, {}, args.cusId).then(
        ({ data }) => {
          if (data) {
            commit("setPurchaseChangeStartDate", data);
            resolve(data);
          } else {
            resolve(false);
          }
        }
      );
    });
  },
  getAppsTab({ commit }) {
    return new Promise((resolve) => {
      get(ENDPOINTS.getAppTabs).then(({ data }) => {
        if (data) {
          commit("setAppsTab", data);
          resolve(true);
        } else {
          resolve(false);
        }
      });
    });
  },
  getProfAlgoTab({ commit }, typeId) {
    return new Promise((resolve) => {
      get(`${ENDPOINTS.getProfAlgoTab}/${typeId}`).then(({ data }) => {
        if (data) {
          commit("setProfAlgoTab", data);
          resolve(true);
        } else {
          resolve(false);
        }
      });
    });
  },
  getHistory({ commit }, customerId = null) {
    return new Promise((resolve) => {
      post(ENDPOINTS.getHistory, state.historyFilter, {}, customerId).then(
        ({ data }) => {
          if (data.data) {
            commit("setHistory", data);
            resolve(true);
          } else {
            resolve(false);
          }
        }
      );
    });
  },
  getHistoryList({ commit }, customerId = null) {
    return new Promise((resolve) => {
      post(ENDPOINTS.getHistoryList, state.historyFilter, {}, customerId).then(
        ({ data }) => {
          if (data.data) {
            commit("setHistoryList", data);
            resolve(true);
          } else {
            resolve(false);
          }
        }
      );
    });
  },
  getInvoiceList({ commit }, customerId = null) {
    return new Promise((resolve) => {
      post(ENDPOINTS.getInvoiceList, state.invoiceFilter, {}, customerId).then(
        ({ data }) => {
          if (data.data) {
            commit("setInvoiceList", data);
            resolve(true);
          } else {
            resolve(false);
          }
        }
      );
    });
  },
  clearReports({ commit }) {
    commit("setRepresentativeReport", { data: [], page: {} });
  },
  getRepresentativeReport({ commit }, callback) {
    return new Promise((resolve) => {
      post(ENDPOINTS.getRepresentativeReport, state.generalFilter).then(
        ({ data }) => {
          if (data) {
            commit("setRepresentativeReport", data);
            resolve(data);
            callback(data);
          } else {
            resolve(false);
          }
        }
      );
    });
  },
  getRepresExportAction({ commit }, callback) {
    return new Promise((resolve) => {
      post(ENDPOINTS.getRepresExport, state.generalFilter).then(({ data }) => {
        if (data) {
          callback(data);
          commit("setRepresReport", data);
          resolve(data);
        } else {
          resolve(false);
        }
      });
    });
  },
  postRepresentativeReport({ commit }, customerId = null) {
    return new Promise((resolve) => {
      post(
        ENDPOINTS.postRepresentationPerson,
        state.historyFilter,
        {},
        customerId
      ).then(({ data }) => {
        if (data) {
          commit("setRepresentativeUsers", data);
          resolve(data);
        } else {
          resolve(false);
        }
      });
    });
  },
  // eslint-disable-next-line no-unused-vars
  updateOverall({ commit }, args) {
    return new Promise((resolve) => {
      post(ENDPOINTS.updateOverallLimit, args).then(({ data }) => {
        if (data) {
          resolve(data);
        } else {
          resolve(false);
        }
      });
    });
  },
  // eslint-disable-next-line no-unused-vars
  getManuelReportExport({ commit }, arg) {
    return new Promise((resolve) => {
      get(`${ENDPOINTS.manuelReportExport}/${arg.year}/${arg.month}`).then(
        ({ data }) => {
          if (data) {
            resolve(data);
          } else {
            resolve(false);
          }
        }
      );
    });
  },
  // eslint-disable-next-line no-unused-vars
  getReportList({ commit }) {
    return new Promise((resolve) => {
      get(ENDPOINTS.reportList).then(({ data }) => {
        if (data) {
          resolve(data);
        } else {
          resolve(false);
        }
      });
    });
  },
  // eslint-disable-next-line no-unused-vars
  getVdsReportExport({ commit }, arg) {
    return new Promise((resolve) => {
      get(`${ENDPOINTS.vdsReportExport}/${arg.year}/${arg.month}`).then(
        ({ data }) => {
          if (data) {
            resolve(data);
          } else {
            resolve(false);
          }
        }
      );
    });
  },
  getPurchaseActivatedStatus({ commit }, Token) {
    return new Promise((resolve) => {
      post(ENDPOINTS.getPurchaseActivatedStatus, Token).then(({ data }) => {
        if (data) {
          commit("setPurchaseActivatedStatus", data);
          resolve(true);
        } else {
          resolve(false);
        }
      });
    });
  },
  //ApplicationType
  getAllApplicationTypes({ commit }) {
    return new Promise((resolve) => {
      get(ENDPOINTS.getAllApplicationTypes, state.generalFilter).then(
        ({ data }) => {
          if (data) {
            commit("setAllApplicationTypes", data);
            resolve(data);
          } else {
            resolve(false);
          }
        }
      );
    });
  },
  deleteApplicationType({ commit }, args) {
    return new Promise((resolve, reject) => {
      _delete(`${ENDPOINTS.deleteApplicationType}/${args.id}`)
        .then((response) => {
          commit("setDeleteApplicationType", response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateApplicationType({ commit }, args) {
    return new Promise((resolve) => {
      put(ENDPOINTS.updateApplicationType, args).then(({ data }) => {
        if (data) {
          commit("setUpdateApplicationType", data);
          resolve(data);
        } else {
          resolve(false);
        }
      });
    });
  },
  createApplicationType({ commit }, args) {
    return new Promise((resolve) => {
      post(ENDPOINTS.createApplicationType, args).then(({ data }) => {
        if (data) {
          commit("setCreateApplicationType", data);
          resolve(data);
        } else {
          resolve(false);
        }
      });
    });
  },
  //Platforms
  getAllPlatforms({ commit }) {
    return new Promise((resolve) => {
      get(ENDPOINTS.getAllPlatforms, state.generalFilter).then(({ data }) => {
        if (data) {
          commit("setAllPlatforms", data);
          resolve(data);
        } else {
          resolve(false);
        }
      });
    });
  },
  deletePlatform({ commit }, args) {
    return new Promise((resolve, reject) => {
      _delete(`${ENDPOINTS.deletePlatform}/${args.id}`)
        .then((response) => {
          commit("setDeletePlatform", response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updatePlatform({ commit }, args) {
    return new Promise((resolve) => {
      put(ENDPOINTS.updatePlatform, args).then(({ data }) => {
        if (data) {
          commit("setUpdatePlatform", data);
          resolve(data);
        } else {
          resolve(false);
        }
      });
    });
  },
  createPlatform({ commit }, args) {
    return new Promise((resolve) => {
      post(ENDPOINTS.createPlatform, args).then(({ data }) => {
        if (data) {
          commit("setCreatePlatform", data);
          resolve(data);
        } else {
          resolve(false);
        }
      });
    });
  },
  //Perspective
  getAllPerspectives({ commit }) {
    return new Promise((resolve) => {
      get(ENDPOINTS.getAllPerspectives, state.generalFilter).then(
        ({ data }) => {
          if (data) {
            commit("setAllPerspectives", data);
            resolve(data);
          } else {
            resolve(false);
          }
        }
      );
    });
  },
  deletePerspective({ commit }, args) {
    return new Promise((resolve, reject) => {
      _delete(`${ENDPOINTS.deletePerspective}/${args.id}`)
        .then((response) => {
          commit("setDeletePerspective", response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updatePerspective({ commit }, args) {
    return new Promise((resolve) => {
      put(ENDPOINTS.updatePerspective, args).then(({ data }) => {
        if (data) {
          commit("setUpdatePerspective", data);
          resolve(data);
        } else {
          resolve(false);
        }
      });
    });
  },
  createPerspective({ commit }, args) {
    return new Promise((resolve) => {
      post(ENDPOINTS.createPerspective, args).then(({ data }) => {
        if (data) {
          commit("setCreatePerspective", data);
          resolve(data);
        } else {
          resolve(false);
        }
      });
    });
  },
  //AKD
  getAllAKDs({ commit }) {
    return new Promise((resolve) => {
      get(ENDPOINTS.getAllAKDs, state.generalFilter).then(({ data }) => {
        if (data) {
          commit("setAllAKDs", data);
          resolve(data);
        } else {
          resolve(false);
        }
      });
    });
  },
  deleteAKD({ commit }, args) {
    return new Promise((resolve, reject) => {
      _delete(`${ENDPOINTS.deleteAKD}/${args.id}`)
        .then((response) => {
          commit("setDeleteAKD", response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateAKD({ commit }, args) {
    return new Promise((resolve) => {
      put(ENDPOINTS.updateAKD, args).then(({ data }) => {
        if (data) {
          commit("setUpdateAKD", data);
          resolve(data);
        } else {
          resolve(false);
        }
      });
    });
  },
  createAKD({ commit }, args) {
    return new Promise((resolve) => {
      post(ENDPOINTS.createAKD, args).then(({ data }) => {
        if (data) {
          commit("setCreateAKD", data);
          resolve(data);
        } else {
          resolve(false);
        }
      });
    });
  },
  //Market
  getAllMarkets({ commit }) {
    return new Promise((resolve) => {
      get(ENDPOINTS.getAllMarkets, state.generalFilter).then(({ data }) => {
        if (data) {
          commit("setAllMarkets", data);
          resolve(data);
        } else {
          resolve(false);
        }
      });
    });
  },
  deleteMarket({ commit }, args) {
    return new Promise((resolve, reject) => {
      _delete(`${ENDPOINTS.deleteMarket}/${args.id}`)
        .then((response) => {
          commit("setDeleteMarket", response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateMarket({ commit }, args) {
    return new Promise((resolve) => {
      put(ENDPOINTS.updateMarket, args).then(({ data }) => {
        if (data) {
          commit("setUpdateMarket", data);
          resolve(data);
        } else {
          resolve(false);
        }
      });
    });
  },
  createMarket({ commit }, args) {
    return new Promise((resolve) => {
      post(ENDPOINTS.createMarket, args).then(({ data }) => {
        if (data) {
          commit("setCreateMarket", data);
          resolve(data);
        } else {
          resolve(false);
        }
      });
    });
  },
  //AlgorithmAndServer
  getAllAlgorithmAndServers({ commit }, args) {
    return new Promise((resolve) => {
      get(ENDPOINTS.getAllAlgorithmAndServers, args).then(({ data }) => {
        if (data) {
          commit("setAllAlgorithmAndServers", data);
          resolve(data);
        } else {
          resolve(false);
        }
      });
    });
  },
  // eslint-disable-next-line no-unused-vars
  getFeatureSettingList({ commit }, args) {
    return new Promise((resolve) => {
      get(ENDPOINTS.featureSettings, args).then(({ data }) => {
        if (data) {
          resolve(data);
        } else {
          resolve(false);
        }
      });
    });
  },
  // eslint-disable-next-line no-unused-vars
  copyFeatureSettingItem({ commit }, args) {
    return new Promise((resolve) => {
      post(`${ENDPOINTS.copyFeatureSetting}`, args).then(({ data }) => {
        if (data) {
          resolve(data);
        } else {
          resolve(false);
        }
      });
    });
  },
  // eslint-disable-next-line no-unused-vars
  copyAlgorithmsItem({ commit }, args) {
    return new Promise((resolve) => {
      post(`${ENDPOINTS.copyAlgorithms}`, args).then(({ data }) => {
        if (data) {
          resolve(data);
        } else {
          resolve(false);
        }
      });
    });
  },
  // eslint-disable-next-line no-unused-vars
  copyResearchsItem({ commit }, args) {
    return new Promise((resolve) => {
      post(`${ENDPOINTS.copyResearchs}`, args).then(({ data }) => {
        if (data) {
          resolve(data);
        } else {
          resolve(false);
        }
      });
    });
  },
  // eslint-disable-next-line no-unused-vars
  copyForeignItem({ commit }, args) {
    return new Promise((resolve) => {
      post(`${ENDPOINTS.copyForeign}`, args).then(({ data }) => {
        if (data) {
          resolve(data);
        } else {
          resolve(false);
        }
      });
    });
  },
  deleteAlgorithmAndServer({ commit }, args) {
    return new Promise((resolve, reject) => {
      _delete(
        `${ENDPOINTS.deleteAlgorithmAndServer}/${args.id}/${args.year}/${args.month}`
      )
        .then((response) => {
          commit("setDeleteAlgorithmAndServer", response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateAlgorithmAndServer({ commit }, args) {
    return new Promise((resolve) => {
      put(ENDPOINTS.updateAlgorithmAndServer, args).then(({ data }) => {
        if (data) {
          commit("setUpdateAlgorithmAndServer", data);
          resolve(data);
        } else {
          resolve(false);
        }
      });
    });
  },
  createAlgorithmAndServer({ commit }, args) {
    return new Promise((resolve) => {
      post(ENDPOINTS.createAlgorithmAndServer, args).then(({ data }) => {
        if (data) {
          commit("setCreateAlgorithmAndServer", data);
          resolve(data);
        } else {
          resolve(false);
        }
      });
    });
  },
  // eslint-disable-next-line no-unused-vars
  deActivateAlgorithmAndServer({ commit }, args) {
    return new Promise((resolve) => {
      post(`${ENDPOINTS.deActivateAlgorithmAndServer}/${args.id}`).then(
        ({ data }) => {
          if (data) {
            resolve(data);
          } else {
            resolve(false);
          }
        }
      );
    });
  },
  // eslint-disable-next-line no-unused-vars
  activateAlgorithmAndServer({ commit }, args) {
    return new Promise((resolve) => {
      post(`${ENDPOINTS.activateAlgorithmAndServer}/${args.id}`).then(
        ({ data }) => {
          if (data) {
            resolve(data);
          } else {
            resolve(false);
          }
        }
      );
    });
  },
  // eslint-disable-next-line no-unused-vars
  getSiteSettings({ commit }) {
    return new Promise((resolve) => {
      get(ENDPOINTS.siteSettings).then(({ data }) => {
        if (data) {
          resolve(data);
        } else {
          resolve(false);
        }
      });
    });
  },
  // eslint-disable-next-line no-unused-vars
  updateGlobalMultiplexer({ commit }, args) {
    return new Promise((resolve) => {
      post(ENDPOINTS.updateMultiplexer, args).then(({ data }) => {
        if (data) {
          resolve(data);
        } else {
          resolve(false);
        }
      });
    });
  },
  // eslint-disable-next-line no-unused-vars
  createFeatureSetting({ commit }, args) {
    return new Promise((resolve) => {
      post(ENDPOINTS.createFeatureSetting, args).then(({ data }) => {
        if (data) {
          resolve(data);
        } else {
          resolve(false);
        }
      });
    });
  },
  // eslint-disable-next-line no-unused-vars
  updateFeatureSetting({ commit }, args) {
    return new Promise((resolve) => {
      put(ENDPOINTS.updateFeatureSetting, args).then(({ data }) => {
        if (data) {
          resolve(data);
        } else {
          resolve(false);
        }
      });
    });
  },
  // eslint-disable-next-line no-unused-vars
  deleteFeatureSetting({ commit }, args) {
    return new Promise((resolve, reject) => {
      _delete(
        `${ENDPOINTS.deleteFeatureSetting}/${args.id}/${args.year}/${args.month}`
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // eslint-disable-next-line no-unused-vars
  deActivateFeatureSetting({ commit }, args) {
    return new Promise((resolve, reject) => {
      post(`${ENDPOINTS.deActivateFeatureSetting}/${args.id}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // eslint-disable-next-line no-unused-vars
  activateFeatureSetting({ commit }, args) {
    return new Promise((resolve, reject) => {
      post(`${ENDPOINTS.activateFeatureSetting}/${args.id}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getResearchList({ commit }, args) {
    return new Promise((resolve) => {
      get(ENDPOINTS.researchList, args).then(({ data }) => {
        if (data) {
          commit("setResearchList", data);
          resolve(data);
        } else {
          resolve(false);
        }
      });
    });
  },
  // eslint-disable-next-line no-unused-vars
  createResearch({ commit }, args) {
    return new Promise((resolve) => {
      post(ENDPOINTS.researchCreate, args).then(({ data }) => {
        if (data) {
          resolve(data);
        } else {
          resolve(false);
        }
      });
    });
  },
  // eslint-disable-next-line no-unused-vars
  updateResearch({ commit }, args) {
    return new Promise((resolve) => {
      put(ENDPOINTS.researchUpdate, args).then(({ data }) => {
        if (data) {
          resolve(data);
        } else {
          resolve(false);
        }
      });
    });
  },
  // eslint-disable-next-line no-unused-vars
  deleteResearch({ commit }, args) {
    return new Promise((resolve, reject) => {
      _delete(
        `${ENDPOINTS.researchDelete}/${args.id}/${args.year}/${args.month}`
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // eslint-disable-next-line no-unused-vars
  deActivateResearch({ commit }, args) {
    return new Promise((resolve, reject) => {
      post(`${ENDPOINTS.deActivateResearch}/${args.id}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // eslint-disable-next-line no-unused-vars
  activateResearch({ commit }, args) {
    return new Promise((resolve, reject) => {
      post(`${ENDPOINTS.activateResearch}/${args.id}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getForeignList({ commit }, args) {
    return new Promise((resolve) => {
      get(ENDPOINTS.foreignList, args).then(({ data }) => {
        if (data) {
          commit("setForeignList", data);
          resolve(data);
        } else {
          resolve(false);
        }
      });
    });
  },
  // eslint-disable-next-line no-unused-vars
  createForeign({ commit }, args) {
    return new Promise((resolve) => {
      post(ENDPOINTS.foreignCreate, args).then(({ data }) => {
        if (data) {
          resolve(data);
        } else {
          resolve(false);
        }
      });
    });
  },
  // eslint-disable-next-line no-unused-vars
  updateForeign({ commit }, args) {
    return new Promise((resolve) => {
      put(ENDPOINTS.foreignUpdate, args).then(({ data }) => {
        if (data) {
          resolve(data);
        } else {
          resolve(false);
        }
      });
    });
  },
  // eslint-disable-next-line no-unused-vars
  deleteForeign({ commit }, args) {
    return new Promise((resolve, reject) => {
      _delete(`${ENDPOINTS.foreignDelete}/${args.id}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // eslint-disable-next-line no-unused-vars
  changeApplicationTypeOrderIncrease({ commit }, args) {
    return new Promise((resolve) => {
      post(`${ENDPOINTS.applicationTypeOrderIncrease}/${args.id}`, args).then(
        ({ data }) => {
          if (data) {
            resolve(data);
          } else {
            resolve(false);
          }
        }
      );
    });
  },
  // eslint-disable-next-line no-unused-vars
  changeApplicationTypeOrderDecrease({ commit }, args) {
    return new Promise((resolve) => {
      post(`${ENDPOINTS.applicationTypeOrderDecrease}/${args.id}`, args).then(
        ({ data }) => {
          if (data) {
            resolve(data);
          } else {
            resolve(false);
          }
        }
      );
    });
  },
  // eslint-disable-next-line no-unused-vars
  changePlatformOrderDecrease({ commit }, args) {
    return new Promise((resolve) => {
      post(`${ENDPOINTS.platformOrderDecrease}/${args.id}`, args).then(
        ({ data }) => {
          if (data) {
            resolve(data);
          } else {
            resolve(false);
          }
        }
      );
    });
  },
  // eslint-disable-next-line no-unused-vars
  changePlatformOrderIncrease({ commit }, args) {
    return new Promise((resolve) => {
      post(`${ENDPOINTS.platformOrderIncrease}/${args.id}`, args).then(
        ({ data }) => {
          if (data) {
            resolve(data);
          } else {
            resolve(false);
          }
        }
      );
    });
  },
  // eslint-disable-next-line no-unused-vars
  changeAlgorithmAndServerOrderDecrease({ commit }, args) {
    return new Promise((resolve) => {
      post(
        `${ENDPOINTS.algorithmAndServerOrderDecrease}/${args.id}`,
        args
      ).then(({ data }) => {
        if (data) {
          resolve(data);
        } else {
          resolve(false);
        }
      });
    });
  },
  // eslint-disable-next-line no-unused-vars
  changeAlgorithmAndServerOrderIncrease({ commit }, args) {
    return new Promise((resolve) => {
      post(
        `${ENDPOINTS.algorithmAndServerOrderIncrease}/${args.id}`,
        args
      ).then(({ data }) => {
        if (data) {
          resolve(data);
        } else {
          resolve(false);
        }
      });
    });
  },
  // eslint-disable-next-line no-unused-vars
  changePerspectiveOrderDecrease({ commit }, args) {
    return new Promise((resolve) => {
      post(`${ENDPOINTS.perspectiveOrderDecrease}/${args.id}`, args).then(
        ({ data }) => {
          if (data) {
            resolve(data);
          } else {
            resolve(false);
          }
        }
      );
    });
  },
  // eslint-disable-next-line no-unused-vars
  changePerspectiveOrderIncrease({ commit }, args) {
    return new Promise((resolve) => {
      post(`${ENDPOINTS.perspectiveOrderIncrease}/${args.id}`, args).then(
        ({ data }) => {
          if (data) {
            resolve(data);
          } else {
            resolve(false);
          }
        }
      );
    });
  },
  // eslint-disable-next-line no-unused-vars
  changeMarketOrderDecrease({ commit }, args) {
    return new Promise((resolve) => {
      post(`${ENDPOINTS.marketOrderDecrease}/${args.id}`, args).then(
        ({ data }) => {
          if (data) {
            resolve(data);
          } else {
            resolve(false);
          }
        }
      );
    });
  },
  // eslint-disable-next-line no-unused-vars
  changeMarketOrderIncrease({ commit }, args) {
    return new Promise((resolve) => {
      post(`${ENDPOINTS.marketOrderIncrease}/${args.id}`, args).then(
        ({ data }) => {
          if (data) {
            resolve(data);
          } else {
            resolve(false);
          }
        }
      );
    });
  },
  // eslint-disable-next-line no-unused-vars
  changeAkdOrderDecrease({ commit }, args) {
    return new Promise((resolve) => {
      post(`${ENDPOINTS.akdOrderDecrease}/${args.id}`, args).then(
        ({ data }) => {
          if (data) {
            resolve(data);
          } else {
            resolve(false);
          }
        }
      );
    });
  },
  // eslint-disable-next-line no-unused-vars
  changeAkdOrderIncrease({ commit }, args) {
    return new Promise((resolve) => {
      post(`${ENDPOINTS.akdOrderIncrease}/${args.id}`, args).then(
        ({ data }) => {
          if (data) {
            resolve(data);
          } else {
            resolve(false);
          }
        }
      );
    });
  },
  // eslint-disable-next-line no-unused-vars
  changeResearchOrderDecrease({ commit }, args) {
    return new Promise((resolve) => {
      post(`${ENDPOINTS.researchOrderDecrease}/${args.id}`, args).then(
        ({ data }) => {
          if (data) {
            resolve(data);
          } else {
            resolve(false);
          }
        }
      );
    });
  },

  // eslint-disable-next-line no-unused-vars
  changeResearchOrderIncrease({ commit }, args) {
    return new Promise((resolve) => {
      post(`${ENDPOINTS.researchOrderIncrease}/${args.id}`, args).then(
        ({ data }) => {
          if (data) {
            resolve(data);
          } else {
            resolve(false);
          }
        }
      );
    });
  },
  // eslint-disable-next-line no-unused-vars
  userRoleGetUsersList({ commit }) {
    return new Promise((resolve) => {
      post(ENDPOINTS.userRoleGetUsersList, state.userRole).then(({ data }) => {
        if (data) {
          resolve(data);
        } else {
          resolve(false);
        }
      });
    });
  },
  // eslint-disable-next-line no-unused-vars
  userRoleAddNewUser({ commit }, args) {
    return new Promise((resolve) => {
      post(ENDPOINTS.userRoleAddNewUser, args).then(({ data }) => {
        if (data) {
          resolve(data);
        } else {
          resolve(false);
        }
      });
    });
  },
  // eslint-disable-next-line no-unused-vars
  userRoleRemoveInternalUser({ commit }, args) {
    return new Promise((resolve) => {
      post(ENDPOINTS.userRoleRemoveInternalUser, args).then(({ data }) => {
        if (data) {
          resolve(data);
        } else {
          resolve(false);
        }
      });
    });
  },
};

const mutations = {
  setBranchList(state, data) {
    state.branchList = data;
  },
  //AlgorithmAndServer
  setUpdateAlgorithmAndServer(state, data) {
    state.updateAlgorithmAndServerResponse = data;
  },
  setCreateAlgorithmAndServer(state, data) {
    state.createAlgorithmAndServerResponse = data;
  },
  setDeleteAlgorithmAndServer(state, data) {
    state.deleteAlgorithmAndServerResponse = data;
  },
  setAllAlgorithmAndServers(state, allAlgorithmAndServers) {
    state.allAlgorithmAndServers = allAlgorithmAndServers;
  },
  //ApplicationType
  setUpdateApplicationType(state, data) {
    state.updateApplicationTypeResponse = data;
  },
  setCreateApplicationType(state, data) {
    state.createApplicationTypeResponse = data;
  },
  setDeleteApplicationType(state, data) {
    state.deleteApplicationTypeResponse = data;
  },
  setAllApplicationTypes(state, allApplicationTypes) {
    state.allApplicationTypes = allApplicationTypes;
  },
  //Market
  setUpdateMarket(state, data) {
    state.updateMarketResponse = data;
  },
  setCreateMarket(state, data) {
    state.createMarketResponse = data;
  },
  setDeleteMarket(state, data) {
    state.deleteMarketResponse = data;
  },
  setAllMarkets(state, allMarkets) {
    state.allMarkets = allMarkets;
  },
  //AKD
  setUpdateAKD(state, data) {
    state.updateAKDResponse = data;
  },
  setCreateAKD(state, data) {
    state.createAKDResponse = data;
  },
  setDeleteAKD(state, data) {
    state.deleteAKDResponse = data;
  },
  setAllAKDs(state, allAKDs) {
    state.allAKDs = allAKDs;
  },
  //Perspective
  setUpdatePerspective(state, data) {
    state.updatePerspectiveResponse = data;
  },
  setCreatePerspective(state, data) {
    state.createPerspectiveResponse = data;
  },
  setDeletePerspective(state, data) {
    state.deletePerspectiveResponse = data;
  },
  setAllPerspectives(state, allPerspectives) {
    state.allPerspectives = allPerspectives;
  },
  //Platforms
  setUpdatePlatform(state, data) {
    state.updatePlatformResponse = data;
  },
  setCreatePlatform(state, data) {
    state.createPlatformResponse = data;
  },
  setDeletePlatform(state, data) {
    state.deletePlatformResponse = data;
  },
  setAllPlatforms(state, allPlatforms) {
    state.allPlatforms = allPlatforms;
  },
  setPackages(state, packages) {
    state.packageData = packages;
  },
  setPackageDetail(state, packageDetail) {
    state.packageDetail = packageDetail;
  },
  setDraftPackageDetail(state, draftPackageDetail) {
    state.draftPackageDetail = draftPackageDetail;
  },
  setRecommendedPackageDetail(state, recommendedPackageDetail) {
    state.recommendedPackageDetail = recommendedPackageDetail;
  },
  setCancelPackage(state, cancelPackage) {
    state.cancelPackage = cancelPackage;
  },
  setApps(state, apps) {
    state.apps = apps;
  },
  setAllResearch(state, allResearch) {
    state.allResearch = allResearch;
  },
  setProfAlgoApps(state, profAlgoApps) {
    state.profAlgoApps = profAlgoApps;
  },
  setFilterList(state, filterList) {
    state.filterList = filterList;
  },
  setRecommendedPackages(state, recommendedPackages) {
    state.recommendedPackages = recommendedPackages;
  },
  setRecommendedAllPackages(state, recommendedAllPackages) {
    state.recommendedAllPackages = recommendedAllPackages;
  },
  setFilter(state, data) {
    state.filterData = { ...state.filterData, ...data };
  },
  setGeneralFilter(state, data) {
    state.generalFilter = { ...state.generalFilter, ...data };
  },
  setUserRoleFilter(state, data) {
    state.userRole = { ...state.userRole, ...data };
  },
  setRecommendedFilter(state, data) {
    state.recommendedFilter = { ...state.recommendedFilter, ...data };
  },
  setInvoiceFilter(state, data) {
    state.invoiceFilter = { ...state.invoiceFilter, ...data };
  },
  setHistoryFilter(state, data) {
    state.historyFilter = { ...state.historyFilter, ...data };
  },
  setProductPackageFilter(state, data) {
    state.productPackageManagementFilter = { ...data };
  },

  setProductPackageAlgoFilter(state, data) {
    state.productPackageManagementAlgoFilter = { ...data };
  },

  setProductPackageForeignFilter(state, data) {
    state.productPackageManagementForeignFilter = { ...data };
  },

  setProductPackageResearchFilter(state, data) {
    state.productPackageManagementResearchFilter = { ...data };
  },

  setProductPackageProductFilter(state, data) {
    state.productPackageManagementProductFilter = { ...data };
  },

  setUpdatePackage(state, data) {
    state.updatePackageResponse = data;
  },
  setUpdateRecommendationPackage(state, data) {
    state.updateRecommendationPackageResponse = data;
  },
  setConfirm(state, data) {
    state.confirm = data;
  },
  setCreatePackage(state, data) {
    state.createPackageResponse = data;
  },
  setAlgorithmCreate(state, data) {
    state.algorithmCreateResponse = data;
  },
  setResearchCreate(state, data) {
    state.researchCreateResponse = data;
  },
  setPackageSummary(state, data) {
    state.packageSummary = data;
  },
  setDraftSummary(state, data) {
    state.draftSummary = data;
  },
  setAppsTab(state, data) {
    state.appsTab = data;
  },
  setProfAlgoTab(state, data) {
    state.profAlgoTab = data;
  },
  setHistory(state, data) {
    state.history = data;
  },
  setHistoryList(state, data) {
    state.historyList = data;
  },
  setInvoiceList(state, data) {
    state.invoiceList = data;
  },
  setRepresentativeReport(state, data) {
    state.representativeReport = data;
  },
  setRepresReport(state, data) {
    state.represReport = data;
  },
  setRepresentativeUsers(state, data) {
    state.representativeUsers = data;
  },
  setPurchaseActivatedStatus(state, data) {
    state.purchaseActivatedStatus = data;
  },
  setRecommendationSummary(state, data) {
    state.recommendationSummary = data;
  },
  setPurchaseChangeStartDate(state, data) {
    state.purchaseChangeStartDate = data;
  },
  setResearchList(state, data) {
    state.researchList = data;
  },
  setForeignList(state, data) {
    state.researchList = data;
  },
  setOverallLimit(state, data) {
    state.overallLimit = data;
  },
  setIsPurchaseOrUpgradeHappend(state, data) {
    state.isPurchaseOrUpgradeHappend = data;
  },
  setUpgradeHappend(state, data) {
    state.isUpgradeHappend = data;
  },
};

const getters = {
  getBranchList() {
    return state.branchList;
  },
  //AlgorithmAndServer
  createAlgorithmAndServer() {
    return state.createAlgorithmAndServer;
  },
  updateAlgorithmAndServer() {
    return state.updateAlgorithmAndServer;
  },
  deleteAlgorithmAndServer() {
    return state.deleteAlgorithmAndServer;
  },
  allAlgorithmAndServers() {
    return state.allAlgorithmAndServers;
  },
  //ApplicationType
  createApplicationType() {
    return state.createApplicationType;
  },
  updateApplicationType() {
    return state.updateApplicationType;
  },
  deleteApplicationType() {
    return state.deleteApplicationType;
  },
  allApplicationTypes() {
    return state.allApplicationTypes;
  },
  //Market
  createMarket() {
    return state.createMarket;
  },
  updateMarket() {
    return state.updateMarket;
  },
  deleteMarket() {
    return state.deleteMarket;
  },
  allMarkets() {
    return state.allMarkets;
  },
  //AKD
  createAKD() {
    return state.createAKD;
  },
  updateAKD() {
    return state.updateAKD;
  },
  deleteAKD() {
    return state.deleteAKD;
  },
  allAKDs() {
    return state.allAKDs;
  },
  //Perspective
  createPerspective() {
    return state.createPerspective;
  },
  updatePerspective() {
    return state.updatePerspective;
  },
  deletePerspective() {
    return state.deletePerspective;
  },
  allPerspectives() {
    return state.allPerspectives;
  },
  //platforms
  createPlatform() {
    return state.createPlatform;
  },
  updatePlatform() {
    return state.updatePlatform;
  },
  deletePlatform() {
    return state.deletePlatform;
  },
  allPlatforms() {
    return state.allPlatforms;
  },
  allPackages() {
    return state.packageData;
  },
  getPackageInfo() {
    return state.packageDetail;
  },
  getDraftPackageDetails() {
    return state.draftPackageDetail;
  },
  getProductManagementFilter() {
    return state.productPackageManagementFilter;
  },
  getProductManagementAlgoFilter() {
    return state.productPackageManagementAlgoFilter;
  },
  getProductManagementForeignFilter() {
    return state.productPackageManagementForeignFilter;
  },
  getProductManagementResearchFilter() {
    return state.productPackageManagementResearchFilter;
  },
  getProductManagementProductFilter() {
    return state.productPackageManagementProductFilter;
  },
  getOverallLimit() {
    return state.overallLimit;
  },
  recommendedPackageInfo() {
    return state.recommendedPackageDetail;
  },
  packageSummary() {
    return state.packageSummary;
  },
  draftSummary() {
    return state.draftSummary;
  },
  apps() {
    return state.apps;
  },
  allResearch() {
    return state.allResearch;
  },
  profAlgoApps() {
    return state.profAlgoApps;
  },
  appsTab() {
    return state.appsTab;
  },
  profAlgoTab() {
    return state.profAlgoTab;
  },
  history() {
    return state.history;
  },
  historyList() {
    return state.historyList;
  },
  getRecommendedPackages() {
    return state.recommendedPackages;
  },
  recommendedAllPackages() {
    return state.recommendedAllPackages;
  },
  getFilterData() {
    return state.filterData;
  },
  getConfirm() {
    return state.confirm;
  },
  getFilterList() {
    return state.filterList.map((item) => {
      const values = item.values.map((data) => {
        return { code: data.key, label: data.value };
      });

      return {
        ...item,
        values,
      };
    });
  },
  getRepresentativeUsers() {
    return state.representativeUsers;
  },
  getRepresExports() {
    return state.represReport;
  },
  invoiceList() {
    return state.invoiceList;
  },
  representativeReport() {
    return state.representativeReport;
  },
  purchaseActivatedStatus() {
    return state.purchaseActivatedStatus;
  },
  recommendationSummary() {
    return state.recommendationSummary;
  },
  purchaseChangeStartDate() {
    return state.purchaseChangeStartDate;
  },
  generalFilter() {
    return state.generalFilter;
  },
  userRoleFilter() {
    return state.userRole;
  },
  getRecoFilter() {
    return state.recommendedFilter;
  },
  getInvoiceFilter() {
    return state.invoiceFilter;
  },
  getHistoryFilter() {
    return state.historyFilter;
  },
  researchList() {
    return state.researchList;
  },
  foreignList() {
    return state.foreignList;
  },
  getIsPurchaseOrUpgradeHappend() {
    return state.isPurchaseOrUpgradeHappend;
  },
  getIsUpgradeHappend() {
    return state.isUpgradeHappend;
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
